/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjcxIDIuMDAwMDFMOCAxLjI5MDAxTDEuMjkgOC4wMDAwMUw4IDE0LjcxTDguNzEgMTRMMi43MSA4LjAwMDAxTDguNzEgMi4wMDAwMVoiIGZpbGw9ImluaGVyaXQiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjQyIDIuMDAwMDFMMTMuNzEgMS4yOTAwMUw3IDguMDAwMDFMMTMuNzEgMTQuNzFMMTQuNDIgMTRMOC40MiA4LjAwMDAxTDE0LjQyIDIuMDAwMDFaIiBmaWxsPSJpbmhlcml0Ii8+";